import React, { Component } from "react";
import Logo from "../Logo/Logo";
import * as H from "./Header-style";


export default class Header extends Component {
   render() {

      let color = {
         colorFont: 'rgba(255, 255, 255, 1)',
         colorTriangel: 'rgba(0, 164, 229, 1)',
         fontSize: '1.43rem'
      };


      return (
         <H.Header>
            <div>
               <H.HeaderFon>
                  <H.HeaderFonImg src={require(`./Header_image-jpg/HeaderFon.jpg`)} alt="fon image"></H.HeaderFonImg>
               </H.HeaderFon>
               <H.LogoPosition>
                  <Logo options={color} />
               </H.LogoPosition>
               <H.HeaderTitleBlock>
                  <H.HeaderTitle>Partner with construct</H.HeaderTitle>
                  <H.HeaderCubtitle>An award-winning construction management firm</H.HeaderCubtitle>
               </H.HeaderTitleBlock>
               <H.HeaderScroll>scroll down</H.HeaderScroll>
            </div>
         </H.Header>
      )
   }
}